import { get, post, put, getViaWebWorker, postViaWebWorker } from './API'
import * as constants from '../../mixins/constants'
import jwtDecode from 'jwt-decode'

export const countries = (params) => {
  const uri = constants.API.order.countries
  return get(uri, params, { token_required: false })
}

export const cities = (params) => {
  const uri = constants.API.order.cities
  return get(uri, params, { token_required: false })
}

export const serviceTypes = (params) => {
  const uri = constants.API.order.service_types_v3

  let options = {
    token_required_header: true,
    headers: {
      'Accepts-Version': constants.ACCEPTS_VERSION
    }
  }

  delete params.token

  // if (params.delivery_type === 'RENTAL') {
  //   delete params.token
  //   options.token_required_header = true
  // }

  if (params.delivery_type) {
    options = {
      ...options,
      // stringify_data: false,
      array_format: 'repeat'
    }
  }

  return getViaWebWorker(uri, params, options)
}

export const serviceDetail = (params) => {
  const uri = constants.API.order.service_detail
  return get(uri, params, { token_required: false })
}

export const list = (params) => {
  const uri = constants.API.order.list
  return get(uri, params)
}

export const getOrderDetail = async (params = {}) => {
  let uri = ''

  if (params.order_id) {
    if (params.order_id.substring(0, 3) === 'ICT') {
      uri = constants.API.nationwide.orderDetailICT(params)
    } else {
      if (params.user_id) {
        uri = constants.API.order.public_detail(params)
      } else {
        uri = constants.API.order.detail(params)
      }
    }
  }

  const response = await get(uri, params)
  return new Promise((resolve, reject) => {
    const { status, data } = response || {}
    if (status === 200) {
      resolve(data)
    } else {
      reject(response)
    }
  })
}
export const getOrderDetailICT = (params = {}) => {
  let uri = ''

  if (params.order_id) {
    uri = constants.API.nationwide.orderDetailICT(params)
  }

  return getViaWebWorker(uri, params)
}

export const locateSupplier = (params) => {
  const uri = constants.API.order.locate_supplier
  return get(uri, params)
}

export const rateSupplier = (params) => {
  const uri = constants.API.order.rate_supplier
  return get(uri, params)
}

export const rateSupplierV3 = (orderId = '', params = {}) => {
  const uri = constants.API.order.rate_supplier_v3({ order_id: orderId })
  return put(uri, params, {
    token_required_header: true,
    stringify_data: false
  })
}

export const createTicket = (params) => {
  const uri = constants.API.order.create_ticket
  return get(uri, params)
}

export const createTicketV3 = (params) => {
  const user = jwtDecode(params.token)
  let uri
  if (user.typ === 'supplier') {
    uri = constants.API.ticket_supplier.create_ticket
  } else {
    uri = constants.API.ticket.create_ticket
  }
  return post(uri, params, { stringify_data: false })
}

export const shareLink = (params) => {
  const uri = constants.API.order.share_link
  return get(uri, params)
}

export const nearbySuppliers = (params) => {
  const uri = constants.API.order.nearby_suppliers
  return get(uri, params)
}

export const verifySupplierUniform = (params) => {
  const uri = constants.API.order.verify_supplier_uniform
  return get(uri, params)
}

export const updateDestinationInfo = (params) => {
  const uri = constants.API.order.update_destination_info
  return get(uri, params)
}

export const updateRecipientAddress = (params) => {
  const uri = constants.API.order.update_recipient_address
  return get(uri, params)
}

export const unconfirmed = (params) => {
  const uri = constants.API.order.unconfirmed
  return get(uri, params)
}

export const confirm = (params) => {
  const uri = constants.API.order.confirm
  return get(uri, params)
}

export const payOrder = (params, config = {}) => {
  const uri = constants.API.payment.pay_order
  return post(uri, params, {
    stringify_data: false,
    ...config
  })
}

export const confirmReturnPackage = (params) => {
  const uri = constants.API.rest_api.confirm_return_package
  return get(uri, params, { baseURL: process.env.VUE_APP_REST_API })
}

export const estimatedFee = (params) => {
  const uri = constants.API.order.estimated_fee
  return post(uri, params, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: 'application/json'
    }
  })
  // return postViaWebWorker(uri, params, {
  // 	headers: {
  // 		'Content-Type': 'application/json'
  // 	}
  // })
}

export const estimatedFeeV2 = (params) => {
  const uri = constants.API.order.estimated_fee_v2
  return postViaWebWorker(uri, params, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const estimatedFeeV3User = (params) => {
  const uri = constants.API.order.estimated_fee_v3_user
  return postViaWebWorker(uri, params, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const estimatedFeeV3Partner = (params) => {
  const uri = constants.API.order.estimated_fee_v3_partner
  return postViaWebWorker(uri, params, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const owEstimatedFeeGW = (params) => {
  const uri = '/api/v3/saas/order/estimate'
  return postViaWebWorker(uri, params, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const owCreateGW = (params, config) => {
  const uri = '/api/v3/saas/order/create'
  return postViaWebWorker(uri, params, {
    token_required_header: config && config.token_required_header,
    headers: {
      'Content-Type': 'application/json'
    },
    stringify_data: false
  })
}

export const estimatedFeeGW = (params) => {
  const uri = constants.API.order_gw.estimated_fee
  return postViaWebWorker(uri, params, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const createGW = (params, config) => {
  const uri = constants.API.order_gw.create
  return postViaWebWorker(uri, params, {
    token_required_header: config && config.token_required_header,
    headers: {
      'Content-Type': 'application/json'
    },
    stringify_data: false
  })
}

export const estimatedFeeRental = (params) => {
  const uri = constants.API.order.estimated_fee_rental
  return postViaWebWorker(uri, params, {
    token_required_header: true,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
export const suggestService = (params) => {
  const uri = constants.API.order.suggestService
  return post(uri, params, {
    stringify_data: false,
    token_required_header: true,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    timeout: 20000
  })
}

export const acEstimatedFee = (params) => {
  const uri = constants.API.onwheel_utils.ac_estimate_fee
  const payload = {
    path: params.path,
    saas_fields: params.saas_fields
  }
  return postViaWebWorker(uri, payload, {
    baseURL: process.env.VUE_APP_ONWHEEL_UTILS_URL,
    headers: {
      'Content-Type': 'application/json'
    },
    timeout: 50000
  })
}

export const create = (params) => {
  const uri = constants.API.order.create
  return post(uri, params, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: 'application/json'
    },
    timeout: 10000
  })
}

export const createOrderV3User = (params) => {
  const uri = constants.API.order.create_v3_user
  return postViaWebWorker(uri, params, {
    headers: {
      'Content-Type': 'application/json'
    },
    token_required_header: true
  })
}

export const createOrderV3Partner = (params) => {
  const uri = constants.API.order.create_v3_partner
  return postViaWebWorker(uri, params, {
    headers: {
      'Content-Type': 'application/json'
    },
    token_required_header: true
  })
}

export const createRental = (params) => {
  const uri = constants.API.order.create_rental_order

  return postViaWebWorker(uri, params, {
    token_required_header: true,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const cancel = (params) => {
  const uri = constants.API.order.cancel
  return get(uri, params)
}

export const cancelV3User = (params = {}) => {
  if (!params.order_id) {
    console.error('cancelV3User required order_id')
    return
  }

  const uri = constants.API.order.cancel_v3_user

  return put(uri, params, {
    token_required_header: true,
    stringify_data: false
  })
}

export const cancelV3Partner = (params = {}) => {
  const missingParams = ['order_id', 'comment', 'cancel_code'].filter((key) => !params[key])

  if (missingParams.length > 0) {
    console.error(`cancelV3Partner missing required params: ${missingParams.join(', ')}`)
    return
  }

  const uri = constants.API.order.cancel_v3_partner

  return put(uri, params, {
    token_required_header: true,
    stringify_data: false
  })
}

export const meta = (params) => {
  const uri = constants.API.order.meta
  return get(uri, params, { baseURL: process.env.VUE_APP_ORDER_META_BASE_URL })
}

export const getOrderMeta = (params) => {
  const uri = constants.API.order.order_meta
  return get(uri, params, {
    token_required_header: true
  })
}

export const getPromoList = (params) => {
  const uri = constants.API.user.get_promo_codes
  return getViaWebWorker(uri, params)
}

export const getPromoDetail = (params = {}) => {
  const uri = constants.API.user.get_promo_code + params.code
  delete params.code

  return getViaWebWorker(uri, params)
}

export const getFeaturedBanner = (params) => {
  const uri = constants.API.user.get_featured_banner

  return getViaWebWorker(uri, params)
}

// Help Center

export const rateSatisfaction = (params) => {
  const user = jwtDecode(params.token)

  let uri
  if (user.typ === 'supplier') {
    uri = constants.API.ticket_supplier.list
  } else {
    uri = constants.API.ticket.list
  }
  uri = uri + '/' + params.ticket_id + constants.API.ticket.rate_satisfaction
  return postViaWebWorker(uri, params)
}

export const getListTicket = (params) => {
  const user = jwtDecode(params.token)

  let uri
  if (user.typ === 'supplier') {
    uri = constants.API.ticket_supplier.list
  } else {
    uri = constants.API.ticket.list
  }

  return getViaWebWorker(uri, params)
}

export const getTicketComment = (params) => {
  const user = jwtDecode(params.token)

  let uri
  if (user.typ === 'supplier') {
    uri = constants.API.ticket_supplier.list
  } else {
    uri = constants.API.ticket.list
  }
  uri = uri + '/' + params.ticket_id + constants.API.ticket.comment
  delete params.ticket_id
  return get(uri, params)
}

export const commentTicket = (params) => {
  const user = jwtDecode(params.token)

  let uri
  if (user.typ === 'supplier') {
    uri = constants.API.ticket_supplier.list
  } else {
    uri = constants.API.ticket.list
  }
  uri = uri + '/' + params.ticket_id + constants.API.ticket.comment
  return post(uri, params, {
    stringify_data: false,
    token_required_header: true
  })
}

export const getListServices = (param) => {
  const uri = constants.API.order.service_types_v3

  const headers = {
    'Accepts-Version': constants.ACCEPTS_VERSION
  }

  return get(uri, param, { ...headers, stringify_data: false })
}

export const getOrderListByToken = (param) => {
  const uri = constants.API.order.list
  return get(uri, param, { stringify_data: false })
}

export const getWarehousePackages = (params) => {
  const uri = constants.API.WAREHOUSE_V2.getListPackage
  return getViaWebWorker(uri, params, {
    token_required_header: true,
    headers: {
      'Content-Type': 'application/json'
    },
    baseURL: process.env.VUE_APP_REST_API,
    timeout: 60000
  })
}

export const getWarehouseMeta = (params) => {
  const uri = constants.API.WAREHOUSE_V2.getMeta
  return getViaWebWorker(uri, params, {
    headers: {
      'Content-Type': 'application/json'
    },
    baseURL: process.env.VUE_APP_REST_API,
    timeout: 60000
  })
}

export const getWarehouseMetaV3 = (params) => {
  const uri = constants.API.WAREHOUSE_V3.getMeta
  return getViaWebWorker(uri, params, {
    headers: { 'Content-Type': 'application/json' },
    token_required_header: true,
    baseURL: process.env.VUE_APP_REST_API,
    timeout: 60000
  })
}

export const getWarehousePackage = (id) => {
  const uri = `${constants.API.WAREHOUSE_V2.getPackage}/${id}`
  return getViaWebWorker(
    uri,
    {},
    {
      headers: {
        'Content-Type': 'application/json'
      },
      baseURL: process.env.VUE_APP_REST_API,
      timeout: 60000
    }
  )
}

export const getWarehousePackageV3 = (id) => {
  const uri = `${constants.API.WAREHOUSE_V3.getPackage}/${id}`
  return getViaWebWorker(
    uri,
    {},
    {
      headers: { 'Content-Type': 'application/json' },
      token_required_header: true,
      baseURL: process.env.VUE_APP_API_URL,
      timeout: 60000
    }
  )
}

export const getWarehousePackageV2 = (id, params) => {
  let uri = `${constants.API.WAREHOUSE_V2.getPackage}/${id}`
  return getViaWebWorker(uri, params, {
    headers: {
      'Content-Type': 'application/json'
    },
    baseURL: process.env.VUE_APP_REST_API,
    timeout: 60000
  })
}

export const getWarehousePackageDetail = (params) => {
  const uri = constants.API.rest_api.get_waiting_order_by_id
  return getViaWebWorker(uri, params, {
    headers: {
      'Content-Type': 'application/json'
    },
    baseURL: process.env.VUE_APP_REST_API,
    // timeout: 20000
    timeout: 15000
  })
}

export const getDraftList = (params) => {
  const uri = constants.API.rest_api.get_draft_list
  return getViaWebWorker(uri, params, {
    headers: {
      'Content-Type': 'application/json'
    },
    baseURL: process.env.VUE_APP_REST_API,
    timeout: 20000
  })
}

export const getDraftDetail = (params) => {
  const uri = constants.API.rest_api.get_draft_detail
  return getViaWebWorker(uri, params, {
    headers: {
      'Content-Type': 'application/json'
    },
    baseURL: process.env.VUE_APP_REST_API,
    timeout: 20000
  })
}

export const saveAsDraftToDB = (params) => {
  const uri = constants.API.rest_api.save_as_draft
  return postViaWebWorker(uri, params, {
    headers: {
      'Content-Type': 'application/json'
    },
    baseURL: process.env.VUE_APP_REST_API,
    timeout: 60000
  })
}

export const getTrendingItems = (params) => {
  const uri = constants.API.order.items.trends
  return getViaWebWorker(uri, params, {
    headers: {
      'Content-Type': 'application/json'
    },
    timeout: 20000
  })
}

export const getSuggestionItems = (params) => {
  const uri = constants.API.order.items.suggestions
  return getViaWebWorker(uri, params, {
    headers: {
      'Content-Type': 'application/json'
    },
    timeout: 20000
  })
}

export const searchRecordList = (params) => {
  let api = constants.API.order.list
  if (params.term || params.tags || params.service_ids || params.child_ids) {
    api = constants.API.order.search
  }

  return getViaWebWorker(api, params, {
    stringify_data: false,
    headers: {
      'Content-Type': 'application/json'
    },
    timeout: 20000
  })
}

export const searchRecordListOnwheel = (params) => {
  let api = constants.API.order.list_by_web
  if (params.term || params.tags || params.child_ids) {
    api = constants.API.order.search
  }
  if (params.service_ids) {
    api = constants.API.order.list_by_web
    delete params.term
    // delete params.tags
    // delete params.child_ids
  }

  const options = {
    stringify_data: false,
    headers: {
      'Content-Type': 'application/json'
    },
    timeout: 20000
  }
  // OW-2166: `/order/search` proxy qua onwheel-utils — BE tự quyết partner nào swap SAAS_TOKEN.
  // list_by_web (`/web/order/list`) đã dùng saas_token sẵn, không cần proxy.
  if (api === constants.API.order.search) {
    options.baseURL = `${process.env.VUE_APP_ONWHEEL_UTILS_API_URL}/v1/proxy`
  }

  return getViaWebWorker(api, params, options)
}

export const confirmReimbursementFee = (params) => {
  const uri = constants.API.order.reimbursement
  return postViaWebWorker(uri, params, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
export const listReasonCancelOrder = (params) => {
  const uri = constants.API.order.list_reason_cancel_order
  return getViaWebWorker(uri, params, {
    token_required: false,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
export const vehicleTypes = () => {
  const uri = constants.API.master_data.vehicle_types
  return getViaWebWorker(uri, {}, { token_required: false })
}
export const getPreferServices = (params) => {
  const uri = constants.API.master_data.prefer_services
  return getViaWebWorker(uri, params, { token_required: false })
}
export const getProofOfWork = (params) => {
  const uri = constants.API.master_data.proof_of_work
  return getViaWebWorker(uri, params, { token_required: false })
}

export const pay = ({ payment_type, ...params }) => {
  const uri = `${constants.API.payment.pay}${payment_type}`
  return postViaWebWorker(uri, params, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
